import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { InstallPwaSheet } from '@/components/feature/InstallPwaSheet';
import { AccountSettingsSheet } from '@/components/feature/AccountSettingsSheet';

export default function FarmerSettingsPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [pwaSheetOpen, setPwaSheetOpen] = useState(false);
  const [settingsSection, setSettingsSection] = useState<'security' | 'notifications' | 'preferences' | null>(null);

  if (!user || user.role !== 'Nông hộ') {
    return <Navigate to="/dang-nhap" replace />;
  }

  return (
    <div className="px-4 py-4 pb-4 space-y-4 max-w-[1200px] mx-auto">
      <div>
        <h2 className="text-lg font-bold text-gray-900">Cài đặt</h2>
        <p className="text-xs text-gray-500 mt-0.5">Quản lý cài đặt hệ thống</p>
      </div>

      <div className="space-y-1">
        <button
          type="button"
          onClick={() => navigate('/nong-ho/ho-so')}
          className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-xl cursor-pointer min-h-[56px] text-left"
        >
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-xl bg-agrida-100 flex items-center justify-center">
              <i className="ri-user-settings-line text-agrida-600 text-sm" />
            </span>
            <div>
              <p className="text-sm font-medium text-gray-900">Thông tin tài khoản</p>
              <p className="text-xs text-gray-500">Quản lý thông tin đăng nhập</p>
            </div>
          </div>
          <i className="ri-arrow-right-s-line text-gray-400" />
        </button>

        <button
          type="button"
          onClick={() => setSettingsSection('notifications')}
          className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-xl cursor-pointer min-h-[56px] text-left"
        >
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-xl bg-agrida-100 flex items-center justify-center">
              <i className="ri-notification-3-line text-agrida-600 text-sm" />
            </span>
            <div>
              <p className="text-sm font-medium text-gray-900">Cài đặt thông báo</p>
              <p className="text-xs text-gray-500">Tùy chỉnh thông báo hệ thống</p>
            </div>
          </div>
          <i className="ri-arrow-right-s-line text-gray-400" />
        </button>

        <button
          type="button"
          onClick={() => setSettingsSection('preferences')}
          className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-xl cursor-pointer min-h-[56px] text-left"
        >
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-xl bg-agrida-100 flex items-center justify-center">
              <i className="ri-font-size-2 text-agrida-600 text-sm" />
            </span>
            <div>
              <p className="text-sm font-medium text-gray-900">Hiển thị</p>
              <p className="text-xs text-gray-500">Cỡ chữ và ngôn ngữ</p>
            </div>
          </div>
          <i className="ri-arrow-right-s-line text-gray-400" />
        </button>

        <button
          type="button"
          onClick={() => setSettingsSection('security')}
          className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-xl cursor-pointer min-h-[56px] text-left"
        >
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-xl bg-agrida-100 flex items-center justify-center">
              <i className="ri-shield-check-line text-agrida-600 text-sm" />
            </span>
            <div>
              <p className="text-sm font-medium text-gray-900">Bảo mật</p>
              <p className="text-xs text-gray-500">Đổi mật khẩu và bảo mật tài khoản</p>
            </div>
          </div>
          <i className="ri-arrow-right-s-line text-gray-400" />
        </button>

        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl cursor-pointer min-h-[56px]">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-xl bg-agrida-100 flex items-center justify-center">
              <i className="ri-information-line text-agrida-600 text-sm" />
            </span>
            <div>
              <p className="text-sm font-medium text-gray-900">Về Agrida</p>
              <p className="text-xs text-gray-500">Phiên bản 2.0.0</p>
            </div>
          </div>
          <i className="ri-arrow-right-s-line text-gray-400" />
        </div>

        <button
          type="button"
          onClick={() => setPwaSheetOpen(true)}
          className="w-full flex items-center justify-between p-4 bg-agrida-50 rounded-xl cursor-pointer min-h-[56px] border border-agrida-100 hover:bg-agrida-100 transition-colors"
        >
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-xl bg-agrida-200 flex items-center justify-center">
              <i className="ri-smartphone-line text-agrida-700 text-sm" />
            </span>
            <div>
              <p className="text-sm font-semibold text-agrida-800">Cài Agrida vào màn hình chính</p>
              <p className="text-xs text-agrida-600">Truy cập nhanh không cần mở trình duyệt</p>
            </div>
          </div>
          <i className="ri-arrow-right-s-line text-agrida-400" />
        </button>
      </div>

      <InstallPwaSheet open={pwaSheetOpen} onClose={() => setPwaSheetOpen(false)} />
      {settingsSection && (
        <AccountSettingsSheet open section={settingsSection} onClose={() => setSettingsSection(null)} />
      )}
    </div>
  );
}